import { Phone, Mail, MapPin, Clock, MessageCircle } from "lucide-react";
import { Reveal, ChapterLabel } from "./primitives";
import { CONTACT } from "../../data/site";

const InfoRow = ({ icon: Icon, label, value, href, testid }) => {
  const content = (
    <div className="flex items-start gap-4 border-b border-white/10 py-6">
      <Icon className="mt-1 h-5 w-5 shrink-0 text-[#FF2A2A]" strokeWidth={1.5} />
      <div>
        <p className="font-mono-accent text-[10px] uppercase tracking-[0.2em] text-[#52525B]">
          {label}
        </p>
        <p className="mt-1 font-body text-lg text-[#FAFAFA]">{value}</p>
      </div>
    </div>
  );
  return href ? (
    <a href={href} data-testid={testid} className="block transition-colors duration-300 hover:text-[#FF2A2A]">
      {content}
    </a>
  ) : (
    <div data-testid={testid}>{content}</div>
  );
};

export const Contact = () => {
  return (
    <section
      id="contatti"
      data-testid="contact-section"
      className="relative bg-[#0A0A0A] px-5 py-24 md:px-10 md:py-32"
    >
      <div className="mx-auto max-w-[1400px]">
        <ChapterLabel number="05" title="Contattaci per un appuntamento" />

        <div className="grid grid-cols-1 gap-px border border-white/10 lg:grid-cols-2">
          <Reveal className="bg-[#0A0A0A] p-8 md:p-12">
            <InfoRow
              icon={Phone}
              label="Telefono"
              value={CONTACT.phone}
              href={CONTACT.phoneHref}
              testid="contact-phone"
            />
            <InfoRow
              icon={MessageCircle}
              label="WhatsApp"
              value="Scrivici su WhatsApp"
              href={CONTACT.whatsapp}
              testid="contact-whatsapp"
            />
            <InfoRow
              icon={Mail}
              label="Email"
              value={CONTACT.email}
              href={CONTACT.emailHref}
              testid="contact-email"
            />
            <InfoRow
              icon={MapPin}
              label="Indirizzo"
              value={CONTACT.address}
              testid="contact-address"
            />

            <div className="flex items-start gap-4 py-6" data-testid="contact-hours">
              <Clock className="mt-1 h-5 w-5 shrink-0 text-[#FF2A2A]" strokeWidth={1.5} />
              <div className="w-full">
                <p className="font-mono-accent text-[10px] uppercase tracking-[0.2em] text-[#52525B]">
                  Orari di apertura
                </p>
                <ul className="mt-2 space-y-1">
                  {CONTACT.hours.map((h, i) => (
                    <li key={i} className="flex justify-between font-body text-[#A1A1AA]">
                      <span>{h.day}</span>
                      <span className="text-[#FAFAFA]">{h.time}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <a
              href={CONTACT.phoneHref}
              data-testid="contact-cta-call"
              className="mt-4 flex items-center justify-center gap-3 bg-[#FF2A2A] px-8 py-4 font-display text-sm font-semibold uppercase tracking-wide text-white transition-colors duration-300 hover:bg-white hover:text-black"
            >
              <Phone className="h-4 w-4" />
              Chiama ora: {CONTACT.phone}
            </a>
          </Reveal>

          <Reveal delay={0.1} className="bg-[#0A0A0A]">
            <div className="relative h-[340px] w-full sm:h-[440px] lg:h-full lg:min-h-[560px]">
              <iframe
                title="Mappa Autofficina Ciro Natale"
                data-testid="contact-map"
                src={CONTACT.mapEmbed}
                className="absolute inset-0 h-full w-full border-0"
                style={{ filter: "grayscale(0.25) contrast(1.05)" }}
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
